import { Router } from "./router/router";

export class App {
  private router: Router;

  constructor() {
    const container = document.getElementById("app");
    if (!container) throw new Error("Root container not found");

    this.router = new Router(
      container,
      { path: "/404", pageName: "notfound" },
      { path: "/login", pageName: "login" }
      // Replace this with your actual checkLoggedIn function
      // async () => this.store.getState().user.isAuthenticated
    );

    this.initializeRoutes();

    // Make router accessible globally for navigation
    (window as any).appRouter = this.router;
  }

  private initializeRoutes(): void {
    this.router.addRoute({ path: "/", pageName: "home", protected: true });
    this.router.addRoute({ path: "/register", pageName: "register", protected: false });
    this.router.addRoute({ path: "/household-setup", pageName: "household-setup", protected: false });
    this.router.addRoute({ path: "/recipe", pageName: "recipe", protected: true });
    this.router.addRoute({ path: "/plan", pageName: "plan", protected: true });
    this.router.addRoute({ path: "/shoppinglist", pageName: "shoppinglist", protected: true });
    this.router.addRoute({ path: "/pantry", pageName: "pantry", protected: true });
    this.router.addRoute({ path: "/plantemplate", pageName: "plantemplate", protected: true });
    this.router.addRoute({ path: "/profile", pageName: "profile", protected: true });
  }

  start(): void {
    this.router.init();
  }
}
